import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import EventIcon from '@mui/icons-material/Event';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import ArchiveIcon from '@mui/icons-material/Archive';
import { useTheme } from '@emotion/react';

const ProjectStatusList = (props) => {
    const theme = useTheme();

    const { t } = useTranslation();
    const { runningActivitiesCount, upcomingActivitiesCount, isArchived } = props.project;
    const projectId = props.project.id;

    var listItems = [];

    if (runningActivitiesCount > 0) {
        listItems.push(
            <div key={`RunningActivitiesCount-${projectId}`} style={{...theme.projectStatusChip.default, ...theme.projectStatusChip.runningActivities}}>
                <DirectionsRunIcon />
                <Typography variant="body2">
                    {t('projectPage.labels.totalRunningActivities', { count: runningActivitiesCount })}
                </Typography>
            </div>
        );
    }

    if (upcomingActivitiesCount > 0) {
        listItems.push(
            <div key={`UpcomingActivitiesCount-${projectId}`} style={{...theme.projectStatusChip.default}}>
                <EventIcon />
                <Typography variant="body2">
                    {t('projectPage.labels.totalUpcomingActivities', { count: upcomingActivitiesCount })}
                </Typography>
            </div>
        );
    }

    if (isArchived) {
        listItems.push(
            <div key={`ArchivedActivitiesCount-${projectId}`} style={{...theme.projectStatusChip.default}}>
                <ArchiveIcon />
                <Typography variant="body2">
                    {t('companyPage.text.archivedProject')}
                </Typography>
            </div>
        );
    }

    const renderList = () => {
        return (
            <div style={{ ...props.style }}>
                { listItems.reverse().map(item => item) }
            </div>
        );
    };

    return (
        listItems.length > 0 ? renderList() : null
    );
};

export default ProjectStatusList;
